import { render, staticRenderFns } from "./SoftwareHeader.vue?vue&type=template&id=15c8c3b2&"
import script from "./SoftwareHeader.vue?vue&type=script&lang=js&"
export * from "./SoftwareHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports